<template>
  <div class="user-management-section">
    <!-- Header Section Begins -->
    <div class="level page-info-section">
      <div class="level-left">
        <b>User management</b>
      </div>
      <div class="level-right margin-right-25">
        <button
          class="button is-button-dark-blue is-uppercase invite-user"
          :disabled="!can_add_more_users"
          @click="handleOpenModal('inviteUser')"
        >
          Invite user
        </button>
      </div>
    </div> <!-- Header Section Ends -->
    <hr class="horizontal-row" />
    <!-- Info section Begins -->
    <div class="columns is-block info-section">
      <!-- Users in hellopeter Begins -->
      <div class="column padding-0">
        <div class="columns is-block">
          <div class="column is-flex">
            <span class="section-heading"><b>Users in {{org_name}}</b> &nbsp;&nbsp; <span class="light-text">( {{org_users.length || 0}} / {{ subscriptionInfo.invites.users || 0 }} {{subscriptionInfo.invites.users > 1 ? 'Users' : 'User'}} )</span></span>
          </div>
          <div class="column is-padding-top-0 padding-bottom-0">
            <table class="table is-size-7-touch is-marginless is-fullwidth">
              <thead>
                <tr>
                  <td class="padding-top-0 padding-bottom-0 pending-name">Name</td>
                  <td class="padding-top-0 padding-bottom-0 pending-email">Email</td>
                  <td class="padding-top-0 padding-bottom-0">Role</td>
                  <td class="padding-top-0 padding-bottom-0">Last logged in</td>
                  <td class="padding-top-0 padding-bottom-0"></td>
                </tr>
              </thead>
              <tbody>
                <tr class="margin-bottom-20 table-rows" v-for="(user, index) in org_users">
                  <td class="is-narrow-mobile is-desktop padding-top-0 padding-bottom-0">{{user.full_name}}</td>
                  <td class="is-narrow-mobile is-desktop padding-top-0 padding-bottom-0">{{user.email}}</td>
                  <td class="is-narrow-mobile is-desktop padding-top-0 padding-bottom-0"><span>{{user.role}} &nbsp;<img src="/static/img/home/free-lock-icon.svg" v-if="user.role === 'Business Admin'"></span></td>
                  <td class="is-narrow-mobile is-desktop padding-0"><span class="column is-flex flex-align-centre padding-0">{{user.last_logged_in | prettyDate}}</span></td>
                  <td class="is-narrow-mobile is-desktop padding-top-0 padding-bottom-0 action-links">
                    <div class="columns">
                      <div class="column is-narrow is-flex flex-align-centre padding-top-0">
                        <!--<img src="/static/img/ic-pencil.svg">--> &nbsp;&nbsp;
                        <span class="link" @click="handleOpenModal('editUser', user, index)">Edit</span>
                      </div>
                      <span class="pipe">|</span>
                      <div class="column is-narrow is-flex flex-align-centre padding-top-0">
                        <!--<img src="/static/img/ic-trash.svg">--> &nbsp;&nbsp;
                        <span data-track="Portal User Management - Delete User" class="link" @click="handleOpenModal('deleteUser', user, index)">Delete</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div> <!-- Users in hellopeter Ends -->
      <!-- Pending invitations Begins -->
      <div class="column padding-0 margin-top-20">
        <div class="columns is-block">
          <div class="column is-flex">
            <span class="section-heading"><b>Pending Invitations</b> &nbsp;&nbsp; <span class="light-text">( {{org_pending_users.length <= 1 ? org_pending_users.length + ' user' : (org_pending_users.length || 0) + ' users' }} )</span></span>
          </div>
          <div class="column is-padding-top-0 padding-bottom-0">
            <table class="table is-size-7-touch is-marginless is-fullwidth">
              <thead>
              <tr>
                <td class="padding-top-0 padding-bottom-0 pending-name">Name</td>
                <td class="padding-top-0 padding-bottom-0 pending-email">Email</td>
                <td class="padding-top-0 padding-bottom-0">Role</td>
                <!--<td class="padding-top-0 padding-bottom-0 visibility-hidden">Last logged in</td>-->
                <td class="padding-top-0 padding-bottom-0"></td>
              </tr>
              </thead>
              <tbody>
                <tr class="margin-bottom-20 table-rows" v-for="(user, index) in org_pending_users">
                  <td class="is-narrow-mobile is-desktop padding-top-0 padding-bottom-0">{{user.full_name | formatEmptyData}}</td>
                  <td class="is-narrow-mobile is-desktop padding-top-0 padding-bottom-0">{{user.email}}</td>
                  <td class="is-narrow-mobile is-desktop padding-top-0 padding-bottom-0"><span>{{user.role}} &nbsp;<img src="/static/img/home/free-lock-icon.svg" v-if="user.role === 'Business Admin'"></span></td>
                  <!--<td class="is-narrow-mobile is-desktop padding-0 visibility-hidden"><span class="column is-flex flex-align-centre padding-0">{{user.last_logged_in | prettyDate}}</span></td>--> <!--{{user.last_logged_in | prettyDate}}-->
                  <td class="is-narrow-mobile is-desktop padding-top-0 padding-bottom-0 action-links">
                    <span data-track="Portal User Management - Revoke User Invite" class="link" @click="handleOpenModal('revokeUser', user, index)">Revoke invite</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span
                      class="link"
                      :class="{'is-disabled': user.is_resending}"
                      :disabled="user.is_revoking"
                      @click.prevent="resendInvite(index, user)"
                    >
                    Resend
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div> <!-- Pending invitations Ends -->
    </div> <!-- Info section Ends -->
    <!-- Invite new user Modal -->
    <ModalPopup :showCloseBtn="true" :onBlur="handleCloseModal" v-if="modal.inviteUser.show">
      <!-- Header Begins -->
      <span slot="header">
        <header class="modal-card-head">
          <span class="close-btn" @click="handleCloseModal('inviteUser')">
            <img src="/static/img/cross.svg" alt="close">
          </span>
          <p class="modal-card-title">Invite a new user</p>
          <p class="modal-card-small-title">Enter the details of the user you would like to add to Hellopeter.</p>
        </header>
      </span> <!-- Header Ends -->
      <!-- Body Begins -->
      <span slot="body">
        <form novalidate>
          <div class="level">
            <div class="column padding-left-0 padding-right-0 padding-bottom-0">
              <div class="field">
                <div class="control">
                  <input class="input email-input" type="text" value="" name="email" v-model="inviteForm.email" placeholder="Email address">
                </div>
              </div>
              <div class="field">
                <label class="is-flex flex-justify-start">User role</label>
                <div class="columns is-marginless is-mobile is-flex flex-align-centre">
                  <div class="column is-narrow column-checkbox">
                    <input type="radio" name="role_id" v-model.number="inviteForm.role_id" value="3" checked>
                  </div>
                  <div class="column column-checkbox is-flex flex-align-centre">
                    <span class="has-text-weight-bold">User</span> &nbsp; - &nbsp;
                    <p class="has-text-weight-normal">Can manage reviews</p>
                  </div>
                </div>
                <div class="columns is-marginless is-mobile is-flex flex-align-centre">
                  <div class="column is-narrow column-checkbox">
                    <input type="radio" name="role_id" v-model.number="inviteForm.role_id" value="2">
                  </div>
                  <div class="column column-checkbox is-flex flex-align-centre">
                    <span class="has-text-weight-bold">Admin</span> &nbsp; - &nbsp;
                    <p class="has-text-weight-normal">Has full access</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </span> <!-- Body Ends -->
      <span slot="footer">
        <!-- Footer Desktop Begins -->
        <footer class="modal-card-foot is-hidden-mobile">
          <!-- Dual buttons with static Cancel button -->
          <div class="level-item has-text-centered">
            <button
              data-track="Portal User Management - Invite New User"
              class="button is-button-dark-blue is-uppercase invite-user"
              :class="[{'is-loading': sending}]"
              :disabled="!testEmail"
              @click="submitForm"
            >
              Invite User
            </button>
          </div>
        </footer> <!-- Footer Desktop Ends -->
        <!-- Footer Mobile Begins -->
        <footer class="columns modal-card-foot is-hidden-tablet  w-100">
          <div class="column is-half">
            <button
              data-track="Portal User Management - Invite New User"
              class="button is-button-dark-blue is-uppercase is-fullwidth-mobile is-uppercase"
              :class="[{'is-loading': sending}]"
              :disabled="!testEmail"
              @click="submitForm"
            >
              Invite User
            </button>
          </div>
        </footer> <!-- Footer Mobile Ends -->
      </span> <!-- Header Ends -->
    </ModalPopup> <!-- Invite new user Modal End -->
    <!-- Edit user Modal -->
    <ModalPopup :showCloseBtn="true" :onBlur="handleCloseModal" v-if="modal.editUser.show">
      <!-- Header Begins -->
      <span slot="header">
        <header class="modal-card-head">
          <span class="close-btn" @click="handleCloseModal('editUser')">
            <img src="/static/img/cross.svg" alt="close">
          </span>
          <p class="modal-card-title">Edit user role</p>
        </header>
      </span> <!-- Header Ends -->
      <!-- Body Begins -->
      <span slot="body">
        <form novalidate>
          <div class="level">
            <div class="column padding-left-0 padding-right-0 padding-bottom-0">
              <div class="field">
                <label class="is-flex flex-justify-start">User role</label>
                <div class="columns is-marginless is-mobile is-flex flex-align-centre">
                  <div class="column is-narrow column-checkbox">
                    <input type="radio" name="role_id" v-model.number="editForm.role_id" value="3" checked>
                  </div>
                  <div class="column column-checkbox is-flex flex-align-centre">
                    <span class="has-text-weight-bold">User</span> &nbsp; - &nbsp;
                    <p class="has-text-weight-normal">Can manage reviews</p>
                  </div>
                </div>
                <div class="columns is-marginless is-mobile is-flex flex-align-centre">
                  <div class="column is-narrow column-checkbox">
                    <input type="radio" name="role_id" v-model.number="editForm.role_id" value="2">
                  </div>
                  <div class="column column-checkbox is-flex flex-align-centre">
                    <span class="has-text-weight-bold">Admin</span> &nbsp; - &nbsp;
                    <p class="has-text-weight-normal">Has full access</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </span> <!-- Body Ends -->
      <span slot="footer">
        <!-- Footer Desktop Begins -->
        <footer class="modal-card-foot is-hidden-mobile">
          <!-- Dual buttons with static Cancel button -->
          <div class="level-item has-text-centered">
            <button
              data-track="Portal User Management - Edit User"
              class="button is-button-dark-blue is-uppercase invite-user"
              :class="[{'is-loading': sending}]"
              @click="submitEditForm"
            >
              Save
            </button>
          </div>
        </footer> <!-- Footer Desktop Ends -->
        <!-- Footer Mobile Begins -->
        <footer class="columns modal-card-foot is-hidden-tablet  w-100">
          <div class="column is-half">
            <button
              data-track="Portal User Management - Edit User"
              class="button is-button-dark-blue is-uppercase is-fullwidth-mobile is-uppercase"
              :class="[{'is-loading': sending}]"
              @click="submitEditForm"
            >
              Save
            </button>
          </div>
        </footer> <!-- Footer Mobile Ends -->
      </span> <!-- Header Ends -->
    </ModalPopup> <!-- Edit user Modal End -->
    <!-- Delete user Modal -->
    <ModalPopup :showCloseBtn="true" :onBlur="handleCloseModal" v-if="modal.deleteUser.show">
      <!-- Header Begins -->
      <span slot="header">
        <header class="modal-card-head">
          <span class="close-btn" @click="handleCloseModal('deleteUser')">
            <img src="/static/img/cross.svg" alt="close">
          </span>
          <p class="modal-card-title">Delete user?</p>
          <p class="modal-card-small-title">You are about to delete this user from your account. If you proceed, all access for this user will be revoked.</p>
        </header>
      </span> <!-- Header Ends -->
      <!-- Body Begins -->
      <span slot="body">
      </span> <!-- Body Ends -->
      <span slot="footer">
        <!-- Footer Desktop Begins -->
        <footer class="modal-card-foot is-hidden-mobile">
          <!-- Dual buttons with static Cancel button -->
          <div class="level-item has-text-centered">
            <button
              data-track="Portal User Management - Delete User"
              class="button is-button-dark-blue is-uppercase invite-user"
              :class="{'is-loading': org_users[modal.deleteUser.index].is_deleting}"
              @click="deleteInvite"
            >
              Delete User
            </button>
          </div>
        </footer> <!-- Footer Desktop Ends -->
        <!-- Footer Mobile Begins -->
        <footer class="columns modal-card-foot is-hidden-tablet  w-100">
          <div class="column is-half">
            <button
              data-track="Portal User Management - Delete User"
              class="button is-button-dark-blue is-uppercase is-fullwidth-mobile is-uppercase"
              :class="{'is-loading': org_users[modal.deleteUser.index].is_deleting}"
              @click="deleteInvite"
            >
              Delete User
            </button>
          </div>
        </footer> <!-- Footer Mobile Ends -->
      </span> <!-- Header Ends -->
    </ModalPopup> <!-- Delete user Modal End -->
    <!-- Revoke user Modal -->
    <ModalPopup :showCloseBtn="true" :onBlur="handleCloseModal" v-if="modal.revokeUser.show">
      <!-- Header Begins -->
      <span slot="header">
        <header class="modal-card-head">
          <span class="close-btn" @click="handleCloseModal('revokeUser')">
            <img src="/static/img/cross.svg" alt="close">
          </span>
          <p class="modal-card-title">Revoke Invitation?</p>
          <p class="modal-card-small-title">Are you sure you want to revoke this invitation?</p>
        </header>
      </span> <!-- Header Ends -->
      <!-- Body Begins -->
      <span slot="body">
      </span> <!-- Body Ends -->
      <span slot="footer">
        <!-- Footer Desktop Begins -->
        <footer class="modal-card-foot is-hidden-mobile">
          <!-- Dual buttons with static Cancel button -->
          <div class="level-item has-text-centered">
            <button
              data-track="Portal User Management - Revoke User Invite"
              class="button is-button-dark-blue is-uppercase invite-user"
              :class="[{'is-loading': org_pending_users[modal.revokeUser.index]['is_revoking']}]"
              @click.prevent.stop="revokeInvite"
            >
              Revoke Invitation
            </button>
          </div>
        </footer> <!-- Footer Desktop Ends -->
        <!-- Footer Mobile Begins -->
        <footer class="columns modal-card-foot is-hidden-tablet  w-100">
          <div class="column is-half">
            <button
              data-track="Portal User Management - Revoke User Invite"
              class="button is-button-dark-blue is-uppercase is-fullwidth-mobile is-uppercase"
              :class="[{'is-loading': org_pending_users[modal.revokeUser.index]['is_revoking']}]"
              @click.prevent.stop="revokeInvite"
            >
              Revoke Invitation
            </button>
          </div>
        </footer> <!-- Footer Mobile Ends -->
      </span> <!-- Header Ends -->
    </ModalPopup> <!-- Revoke user Modal End -->
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef, valid-jsdoc, no-useless-escape */
  import axios from 'axios'
  import moment from 'moment'
  import Avatar from 'vue-avatar'
  import { mapState, mapActions } from 'vuex'
  import ApiResource from '@/api/ApiResource'
  import {ModalPopup} from '@/components'
  import { SHOW_MODAL } from '@/store/action.types'

  export default {
    name: 'Users',
    metaInfo: {
      title: 'Business Portal | Hellopeter - Users'
    },
    components: {
      Avatar,
      ModalPopup
    },
    data () {
      return {
        fetching_users: false,
        fetching_pending_users: false,
        fetching: true,
        success_msg: '',
        org_id: localStorage.getItem('org_id'),
        can_invite: JSON.parse(localStorage.getItem('can_invite')),
        subscriptionInfo: {invites: {users: null}},
        can_add_more_users: JSON.parse(localStorage.getItem('can_add_more_users')),
        current_user: localStorage.getItem('email'),
        org_name: localStorage.getItem('org_name'),
        org_slug: localStorage.getItem('org_slug'),
        form: new ApiResource({}),
        sending: false,
        inviteForm: new ApiResource({
          email: '',
          role_id: 3
        }),
        editForm: new ApiResource({
          role_id: '',
          original_role_id: '',
          email: ''
        }),
        org_users: {},
        org_pending_users: {},
        modal_props: {},
        modal: {
          active: null,
          editUser: {show: false, user: null, index: null},
          inviteUser: {show: false},
          deleteUser: {show: false, user: null, index: null},
          revokeUser: {show: false, user: null, index: null}
        }
      }
    },
    computed: {
      ...mapState({
        modalPopup: state => state.app.modal,
        analyticsData: state => state.analytics
      }),
      /**
       * Collect Form Errors
       * @returns {Object}
       */
      hasErrors () {
        return this.inviteForm.errors.any()
      },
      /**
       * Test email is valid or not
       * @returns {Boolean}
       */
      testEmail () {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regex.test(this.inviteForm.email)
      }
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Users'
      })
      this.getUsers()
      this.getPendingUsers()
      this.canBusinessAddUsers()
    },
    created () {
      // listen for the cancelOps event emitted by the Modal component on behalf of the global event hub
      window.events.$on('cancelOps', this.cancelOps)
    },
    destroyed () {
      window.events.$off('cancelOps', this.cancelOps)
    },
    methods: {
      ...mapActions({
        showModal: `app/${SHOW_MODAL}`
      }),
      isCurrentUser (email) {
        return this.current_user === email
      },
      async canBusinessAddUsers () {
        try {
          let canBusinessAddUsers = await axios(`/auth/can-add-more-business-users/${this.org_id}`)
          this.can_add_more_users = JSON.parse(canBusinessAddUsers.data.can_add_more_users)
          this.subscriptionInfo = canBusinessAddUsers.data.subscriptionsInfo
          localStorage.setItem('can_add_more_users', JSON.parse(canBusinessAddUsers.data.can_add_more_users))
        } catch (error) {
          flash('An unexpected error occurred. Please try again later.', 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to get response from Server checking to see if more users can be added on Business Users View',
              'displayedMessage': 'An unexpected error occurred. Please try again later.'
            }
          })
        }
      },
      /**
       * Makes an api call to get list of all accepted users for org
       * @returns {void}
       */
      getUsers () {
        this.org_users = {}
        this.fetching_users = true
        this.form.send(`/business/${this.org_slug}/users/`, {}, 'get')
          .then((users) => {
            this.fetching_users = false
            users.forEach((item, index) => {
              if (users[index]['is_deleting'] === undefined) {
                users[index]['is_deleting'] = false
              }
            })
            this.org_users = users
          })
          .catch(() => {
            this.fetching_users = false
          })
      },
      /**
       * Makes an api call to get list of all pending users for org
       * @returns {void}
       */
      getPendingUsers () {
        this.org_pending_users = {}
        this.fetching_pending_users = true
        this.form.send(`/business/${this.org_slug}/users/?status=pending`, {}, 'get')
          .then((pendingusers) => {
            this.fetching_pending_users = false
            pendingusers.forEach((item, index) => {
              pendingusers[index]['is_revoking'] = false
              pendingusers[index]['is_resending'] = false
            })
            this.org_pending_users = pendingusers
          })
          .catch(() => {
            this.fetching_pending_users = false
          })
      },
      /**
       * Makes an api call to resend an invite
       * @param {number} item index from pending user array
       * @param {object} user user obj of the pending invite to revoke
       * @returns {void}
       */
      resendInvite (item, user) {
        if (!user.is_revoking) {
          this.org_pending_users[item]['is_resending'] = true
          // initialize event producer's props
          let producer = {}
          producer.index = item
          producer.user = user
          producer.task = 'resendInvite'
          this.resendOps(producer)
        }
      },
      /**
       * Makes an api call to revoke an invite
       * @returns {void}
       */
      revokeInvite () {
        this.org_pending_users[this.modal.revokeUser.index]['is_revoking'] = true
        this.form.send(`/auth/${this.modal.revokeUser.user.invite_id}/revoke-invite`, {}, 'get')
        .then(() => {
          this.canBusinessAddUsers()
          flash('Invite was revoked successfully.')
          this.org_pending_users[this.modal.revokeUser.index]['is_revoking'] = false
          this.org_pending_users.splice(this.modal.revokeUser.index, 1)
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully revoked invite on Business Users View',
              'displayedMessage': 'Invite was revoked successfully.'
            }
          })
        })
        .catch((msg) => {
          flash(msg.error, 'is-danger')
          this.org_pending_users[this.modal.revokeUser.index]['is_revoking'] = false
          this.getLatestUsers()
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to revoke invite on Business Users View',
              'displayedMessage': msg.error
            }
          })
        })
        .finally(() => {
          this.handleCloseModal()
          this.getUsers()
          this.getPendingUsers()
        })
      },
      resendOps (producer) {
        if (this.org_pending_users[producer.index]['is_resending']) {
          this.form.send(`/auth/${producer.user.invite_id}/resend-invite`, {}, 'get')
            .then(() => {
              const msg = 'You have successfully resent the invite for ' + producer.user.email + ' (' + producer.user.role + ')'
              flash(msg)
              this.org_pending_users[producer.index]['is_resending'] = false
              dataLayer.push({
                'userMessage': {
                  'messageType': 'success',
                  'messageName': 'Successfully re-sent invite on Business Users View',
                  'displayedMessage': msg
                }
              })
            })
            .catch((msg) => {
              flash(msg.error, 'is-danger')
              this.org_pending_users[producer.index]['is_resending'] = false
              dataLayer.push({
                'userMessage': {
                  'messageType': 'error',
                  'messageName': 'Failed to re-send invite on Business Users View',
                  'displayedMessage': msg.error
                }
              })
            })
        }
      },
      /**
       * Makes an api call to delete a user
       * @returns {void}
       */
      deleteInvite () {
        this.org_users[this.modal.deleteUser.index]['is_deleting'] = true
        this.form.send(`/auth/${this.modal.deleteUser.user.invite_id}/delete-invite`, {}, 'get')
        .then((response) => {
          this.canBusinessAddUsers()
          flash(response)
          this.org_users[this.modal.deleteUser.index]['is_deleting'] = false
          this.org_users.splice(this.modal.deleteUser.index, 1)
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully deleted invite on Business Users View',
              'displayedMessage': response
            }
          })
          this.handleCloseModal()
        })
        .catch((msg) => {
          flash(msg.error, 'is-danger')
          this.org_users[this.modal.deleteUser.index]['is_deleting'] = false
          this.getLatestUsers()
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to delete invite on Business Users View',
              'displayedMessage': msg.error
            }
          })
          this.handleCloseModal()
        })
        .finally(() => {
          this.getUsers()
        })
      },
      cancelOps (props) {
        if (props.task === 'revokeInvite') {
          this.org_pending_users[props.producer.index]['is_revoking'] = false
        }

        if (props.task === 'deleteInvite') {
          this.org_users[props.producer.index]['is_deleting'] = false
        }
      },
      /**
       * Get the latest users both pending and current from api
       * @returns {void}
       */
      getLatestUsers () {
        // get the latest users from the api
        setTimeout(() => {
          this.getPendingUsers()
          this.getUsers()
        }, 3000)
      },
      /**
       * Processes form submission
       * @returns {void}
       */
      submitForm () {
        this.sending = true
        this.success_msg = ''
        this.inviteForm.errors.clear()
        this.inviteForm.send(`/auth/create-invite`, {
          email: this.inviteForm.email,
          role_id: this.inviteForm.role_id,
          org_id: this.org_id
        })
        .then((success) => {
          this.sending = false
          this.success_msg = success
          this.inviteForm.role_id = 3
          flash(success)
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully invited user on Invite Business User View',
              'displayedMessage': success
            }
          })
          this.$router.push('/users')
        })
        .catch(() => {
          this.sending = false
          flash(this.getErrorMessage(), 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to invite user on Invite Business User View',
              'displayedMessage': this.getErrorMessage()
            }
          })
        })
        .finally(() => {
          console.log('Finally block')
          this.handleCloseModal()
          this.getUsers()
          this.getPendingUsers()
          this.resetModal()
        })
      },
      /**
       * Submit the user edit form
       * @returns {void}
       */
      submitEditForm () {
        this.sending = true
        this.editForm.errors.clear()
        this.editForm.send(`/update-users-role/${this.modal.editUser.user.invite_id}`, {
          role_id: this.editForm.role_id,
          invite_id: this.modal.editUser.user.invite_id
        }, 'patch')
        .then((success) => {
          this.sending = false
          this.editForm.role_id = 3
          flash(success)
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully updated user details on Edit Business User View',
              'displayedMessage': success
            }
          })
        })
        .catch(() => {
          this.sending = false
          flash(this.getErrorMessage(), 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to update user details on Edit Business User View',
              'displayedMessage': this.getErrorMessage()
            }
          })
        })
        .finally(() => {
          this.getUsers()
          this.getPendingUsers()
          this.resetModal()
          this.handleCloseModal()
        })
      },
      /**
       * Gets error message from api calls
       * @returns {string}
       */
      getErrorMessage () {
        return this.inviteForm.errors.getDefaultErrorMessage()
      },
      /**
       * Resets all data properties back to default
       * @returns {void}
       */
      resetModal () {
        this.inviteForm.email = ''
        this.inviteForm.role_id = 3
      },
      /**
       * Handle Modal Appearance
       * @param {string} modalType
       * @param {object} user
       * @param {number} loopIndex
       * @returns {void}
       */
      handleOpenModal (modalType, user = null, loopIndex = null) {
        this.showModal(true)
        this.modal.active = modalType
        this.modal[modalType].show = true
        if (user || loopIndex) {
          Object.assign(this.modal[modalType], {
            user: user,
            index: loopIndex
          })
        }
      },
      /**
       * Close modal globally
       * @return {void}
       */
      handleCloseModal () {
        this.showModal(false)
        this.modal[this.modal.active].show = false
        this.modal.active = null
        if (this.org_users[this.modal.deleteUser.index] !== undefined) {
          this.org_users[this.modal.deleteUser.index]['is_deleting'] = false
        }
        if (this.org_pending_users[this.modal.revokeUser.index] !== undefined) {
          this.org_pending_users[this.modal.revokeUser.index]['is_revoking'] = false
        }
      }
    },
    filters: {
      /**
       * Format date in format (i.e 23/01/2021)
       * @param date
       * @return {string}
       */
      prettyDate (date) {
        return date ? moment(date).format('DD/MM/YYYY') : '--'
      },
      /**
       * Format empty string
       * @param val
       * @return {string}
       */
      formatEmptyData (val) {
        return val.length !== 1 ? val : '--'
      }
    }
  }
</script>

<!-- Local CSS Begins -->
<style lang="scss" scoped>
  $text-color: #58595b;
  $link-color: #30aae1;
  $blue-text-color: #1261a0;

  .horizontal-row {
    margin-top: 0;
    margin-bottom: 1rem;
    margin-left: -5%;
    margin-right: -5%;
  }
  .page-info-section {
    position: relative;
    padding: 0 5px 0 31px !important;
    margin-bottom: 0.7rem;

    .level-right {
      .padding-bottom-0 {
        width: 302px;
        padding: 0;
        margin-right: 15px;
      }
    }
    .level-left {
      b {
        font-size: 16px;
        font-weight: bold;
        color: $text-color;

      }
    }

    /*Mobile view*/
    @media screen and (max-width: 767px) {
      display: flex;
      align-items: flex-end;
    }
  }
  .invite-user {
    width: 130px;
  }
  .user-management-section {
    margin-bottom: 5%;

    .section-heading {
      b {
        color: $blue-text-color;
        font-size: 14px;
        font-weight: bold;
      }
      .light-text {
        color: $text-color;
        font-size: 12px;
      }
    }
    .info-section {
      padding: 0 20px;

      .table {
        tbody {
          tr {
            height: 48px;
            background-color: #ffffff !important;

            td {
              color: $text-color;
              font-size: 12px;
              padding: 10px 5px 0 0 !important;
              border-bottom: solid 1px rgba(219,219,219,0.4) !important;
            }
          }
        }

        thead {
          tr td {
            color: $text-color;
            font-size: 12px;
            padding: 5px 5px 5px 0 !important;
            font-weight: bold;
            line-height: 1.42;
            text-align: left;
            border-bottom: solid 1px rgba(219,219,219,0.4) !important;
          }
        }
      }
    }
  }
  .visibility {
    &-hidden {
      visibility: hidden;
    }
  }
  .modal {
    .modal-card-head {
      padding: 20px 20px 0 20px;
      padding-top: 15px;
    }
    .modal-card-title {
      padding: 0 0 10px 0;
      font-size: 16px;
    }
    .modal-card-small-title {
      color: $text-color;
      font-size: 12px;
    }
    .email-input {
      height: 35px;
      font-size: 12px;
    }
    &>>> .modal-card-body {
      font-size: 14px;
    }
  }
  .link {
    color: $link-color;
    cursor: pointer;
    text-decoration: underline;
  }
  .is-disabled {
    color: $text-color;
    pointer-events: none;
  }
  .pipe {
    color: rgba(88,89,91,0.32);
  }
  .action-links {
    width: 15%;
  }
  .pending-name {
    width: 24%;
  }
  .pending-email {
    width: 27%;
  }

  /* Helper css begins */
  .margin {
    &-0 {
      margin: 0;
    }
    &-bottom {
      &-0 {
        margin-bottom: 0;
      }
    }
  }
  .padding {
    &-0 {
      padding: 0;
    }
    &-top {
      padding-top: 0;

      &-bottom {
        &-5 {
          padding: 0 5px;
        }
      }
    }
  }
  .w {
    &-100 {
      width: 100%;
    }
  }
  /* Helper css ends */
</style>
<!-- Local CSS Ends -->
<!-- Global CSS Begins -->
<style>
  div#sideBar .is-padding-top-0 {
    padding-top: 0;
  }
  div#sideBar .is-full-width-view {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  div#sideBar .is-full-width-view .horizontal-row {
    margin-bottom: 0;
  }
</style>
<!-- Global CSS Begins -->



// WEBPACK FOOTER //
// src/pages/users/Users.vue